import React, { useState, useCallback } from 'react'

import api from 'common/api'
import AlertModal from 'components/modal/AlertModal'

import ModalPayCancel from '../../components/modal/ModalPayCancel'
import ModalPortal from '../../ModalPortal'

export default function ButtonPayCancel({
  orderNo,
  orderDate,
  paymentData,
  orderCancelYn,
  orderDetailData
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  // 모달열기
  const handleOpenModal = useCallback((e) => {
    document.body.classList.add('modal-open')
    setIsModalOpen(true)
  }, [])

  // 모달닫기
  const handleCloseModal = useCallback((e) => {
    document.body.classList.remove('modal-open')
    setIsModalOpen(false)
  }, [])

  // 결제 취소 API
  const putPayCancel = useCallback(
    async (cancelReason, reasonCode, orderNo) => {
      if (isLoading) return false

      setIsLoading(true)
      const data = { reason: cancelReason, reasonCode, orderNo }

      try {
        const response = await api.post(`/payment/v2/order/payment/cancel/${orderNo}`, data)

        if (response.data.meta.code !== 200) {
          alert(response.data.meta.message)
          return false
        }

        return true // 성공 여부만 반환
      } catch (e) {
        console.log(e)
        return false
      } finally {
        setIsLoading(false)
      }
    },
    [isLoading]
  )

  return (
    <>
      <button
        className="button stroke btn-cancel"
        onClick={() => {
          handleOpenModal(orderNo)
        }}
      >
        <span>결제 취소</span>
      </button>

      {isModalOpen && (
        <ModalPortal>
          {orderCancelYn ? (
            <ModalPayCancel
              orderNo={orderNo}
              orderDate={orderDate}
              orderDetailData={orderDetailData}
              paymentData={paymentData}
              putPayCancel={putPayCancel}
              btnClose
              handleCloseModal={handleCloseModal}
            />
          ) : (
            <AlertModal
              btnConfirm
              titleMsg="결제 취소 안내"
              msg={'요청하신 상품은 아래 경우에\n해당해 확인이 필요합니다.'}
              customTag={
                <>
                  <div className="notice-box">
                    <p>
                      - <b>배송 또는 수강이 시작</b>된 경우{' '}
                    </p>
                    <p>
                      - <b>무통장 결제</b> (환불 계좌 확인 필요)
                    </p>
                  </div>
                  <p className="info-txt">*환불 신청 : 고객센터(1600-0563)</p>
                </>
              }
              handleCloseModal={handleCloseModal}
            />
          )}
        </ModalPortal>
      )}
    </>
  )
}
